import { render, staticRenderFns } from "./ModalDeverInformar.vue?vue&type=template&id=cbc2cfb6"
import script from "./ModalDeverInformar.vue?vue&type=script&lang=js"
export * from "./ModalDeverInformar.vue?vue&type=script&lang=js"
import style0 from "./ModalDeverInformar.vue?vue&type=style&index=0&id=cbc2cfb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports